<!-- 通用上传附件uploadItem -->
<template>
  <div>
    <el-uploads-choice v-if="!disabled" @success="getSuccess_files" :multiple="multiple">
      <div slot="upButton" class="btn_black_form"><i class="el-icon-paperclip"></i>{{ btnText }}</div>
    </el-uploads-choice>
    <div v-else class="btn_black_form" @click="$message.warning('仅支持单文件上传，请先删除已上传附件')"><i class="el-icon-paperclip"></i>{{ btnText }}</div>
    <div v-show="files_select.length > 0" class="uploadContent">
      <div v-for="(file, i) in files_select" :key="i" style="display: flex">
        <div class="nowrap">{{ file.name }}</div>
        <el-button v-if="!otherOpts" type="text" icon="el-icon-close" style="margin-left: 20px" @click.stop="delFile(file)"></el-button>
        <div v-else class="flexStart" style="margin-left: 20px">
          <el-button type="text" @click.stop="handleFileViewing(file)">预览</el-button>
          <el-button type="text" @click.stop="downFile(file)">下载</el-button>
          <!-- 假删除 -->
          <el-button v-if="falseDelete && !file?.delLine" type="text" @click.stop="falseDeleteFile(file)">删除</el-button>
          <!-- <el-button v-if="falseDelete&&file.delLine" type="text" @click.stop="resetFile(file)">恢复</el-button> -->
          <!-- 真删除 -->
          <el-button v-else-if="!falseDelete" type="text" @click.stop="delFile(file)">删除</el-button>
        </div>
      </div>
    </div>
    <!-- 预览组件 -->
    <PreviewFile ref="previewFile"></PreviewFile>
  </div>
</template>

<script>
import elUploadsChoice from './elUploadsChoice.vue';
import PreviewFile from './file-preview.vue';
export default {
  name: 'uploadItem',
  components: { elUploadsChoice, PreviewFile },
  props: ['placeholder', 'btnText', 'fileItem', 'filesList', 'multiple', 'disabled', 'otherOpts', 'falseDelete'],
  data() {
    return {
      selectVal: '',
      files_select: [],
    };
  },
  watch: {
    filesList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.files_select = newVal;
          this.selectVal = newVal[newVal.length - 1].name;
        } else {
          this.files_select = [];
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 初始化附件信息
    initFiles() {
      if (this.formItem.bill) {
        this.files_select = JSON.parse(this.formItem.bill);
        if (this.files_cost.length > 0) {
          this.fileName_cost = this.files_cost[this.files_cost.length - 1].name;
        }
      }
    },
    // 获取票据上传信息
    getSuccess_files(res) {
      this.files_select.push(res);
      this.$emit('changeFile', this.fileItem, this.files_select);
      this.selectVal = res.name;
    },
    // 删除附件
    delFile(file) {
      this.$msgbox({
        title: '删除附件',
        message: `是否确定删除附件 - ${file.name}?`,
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            let that = this;
            this.$axios
              .post(`api/file/deleteFileByUrl`, {
                fileUrl: file.response ? file.response.url : file.url,
              })
              .then((res) => {
                if (res.data.code == 200) {
                  that.files_select = that.files_select.filter((item) => {
                    if (item.response) {
                      return item.response.url != file.response.url;
                    } else {
                      return item.url != file.url;
                    }
                  });
                  that.$emit('changeFile', that.fileItem, that.files_select);
                  that.selectVal = '';
                  if (that.files_select.length > 0) {
                    that.selectVal = that.files_select[that.files_select.length - 1].name;
                  }
                  that.$message({
                    message: '已删除',
                    type: 'success',
                  });
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: 'error',
                  });
                }
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              })
              .catch(() => {
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              });
          } else {
            //确认弹窗还原&关闭
            instance.confirmButtonText = '确定';
            instance.confirmButtonLoading = false;
            done();
          }
        },
      })
        .then((action) => {})
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
            offset: 100,
          });
        });
    },
    // 预览
    handleFileViewing(file) {
      this.$refs.previewFile.openDrawer([file]);
    },
    //下载
    downFile(file) {
      let url = '';
      if (file.url) {
        url = file.url;
      }
      this.$axios
        .get(url, { responseType: 'blob' })
        .then((res) => {
          const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', file.name);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((e) => {
          this.$message({
            type: 'error',
            message: `${e}`,
            offset: 100,
          });
        });
    },
  },
};
</script>
<style lang="less">
.uploadContent {
  // width: fit-content;
  max-width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-top: 20px;

  > div {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 20px;
    height: 20px;

    > div:first-child {
      color: #b64040;
      flex: 1;
    }
  }
}

@media only screen and (max-width: 700px) {
  .uploadContent {
    min-width: 90%;
  }
}
</style>
